import instanceAxios from '../config/api'
import {
  CoutSupplementaire,
  CoutSupplementaireResponse,
} from '../types/coutSupplementaireTypes'
const API_URL = '/coutSupplementaires'

export const deleteCoutSupplementaireApi = async (
  CoutSupplementaireId: string
) => {
  const response = await instanceAxios.delete<CoutSupplementaire[]>(
    `${API_URL}/` + CoutSupplementaireId
  )
  return response.data
}

export const addCoutSupplementaireApi = async (
  newCoutSupplementaire: CoutSupplementaire
): Promise<CoutSupplementaire> => {
  const response = await instanceAxios.post<CoutSupplementaire>(
    `${API_URL}`,
    newCoutSupplementaire
  )
  return response.data
}

export const getCoutSupplementairebyIdApi = async (
  CoutSupplementaireId: string
) => {
  const response = await instanceAxios.get<CoutSupplementaire>(
    `${API_URL}/` + CoutSupplementaireId
  )
  return response.data
}

export const updateCoutSupplementaireApi = async (
  updatedCoutSupplementaire: CoutSupplementaire,
  _id: string
): Promise<CoutSupplementaire> => {
  const response = await instanceAxios.put<CoutSupplementaire>(
    `${API_URL}/${_id}`,
    updatedCoutSupplementaire
  )
  return response.data
}

export const getCoutSupplementairesByActionIdApi = async (ActionId: string) => {
  const response = await instanceAxios.get<CoutSupplementaireResponse>(
    `actions/getCoutSupplementaires/${ActionId}`
  )
  return response
}
